import axios from 'axios'

export const ContentSectionApi = {
    http: axios.create(),

    async queryXmlIds(xmlIdsQuery) {
        const routeUri = Routing.generate("playground_api_content_section_by_id", xmlIdsQuery);
        let response = await this.http.get(routeUri);
        return response.data.sections;
    }
};
